"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Board_1 = require("./Board");
var List_1 = require("./List");
var Card_1 = require("./Card");
var UI_1 = require("./UI");
var Storage = /** @class */ (function () {
    function Storage() {
    }
    // local storage
    Storage.getLocalStorage = function () {
        Storage.boards = [];
        if (localStorage.getItem("boards") !== null) {
            // if boards local storage isn't empty
            // the json can't store functions, so all the objects need to be remade
            // recreate board objects
            var jsonBoards = JSON.parse(localStorage.getItem("boards"));
            jsonBoards.forEach(function (jsonBoard) {
                var board = new Board_1.Board(jsonBoard.name);
                // recreate list objects
                var jsonLists = jsonBoard.lists;
                jsonLists.forEach(function (jsonList) {
                    var list = new List_1.List(jsonList.name);
                    board.addList(list);
                    // recreate card objects
                    var jsonCards = jsonList.cards;
                    jsonCards.forEach(function (jsonCard) {
                        var card = new Card_1.Card(jsonCard.title, jsonCard.description, jsonCard.priority);
                        list.addCard(card);
                    });
                });
                // push the newly created board object straight into storage
                Storage.boards.push(board);
            });
            UI_1.default.currentBoardIndex = parseInt(localStorage.getItem("lastBoard"));
            console.log(Storage.boards);
        }
    };
    Storage.setLocalStorage = function () {
        localStorage.setItem("boards", JSON.stringify(Storage.boards));
        localStorage.setItem("lastBoard", String(UI_1.default.currentBoardIndex));
    };
    // boards manipulation
    Storage.createBoard = function (name) {
        var newBoard = new Board_1.Board(name);
        Storage.boards.push(newBoard);
        Storage.setLocalStorage();
        return Storage.boards.length - 1; // return index of the new board
    };
    Storage.changeBoardName = function (newName, boardIndex) {
        var board = Storage.boards[boardIndex];
        board.changeName(newName);
        Storage.setLocalStorage();
    };
    Storage.deleteBoard = function (boardIndex) {
        Storage.boards.splice(boardIndex, 1);
        Storage.setLocalStorage();
    };
    // lists manipulation
    Storage.createList = function (name, boardIndex) {
        var board = Storage.boards[boardIndex];
        var list = new List_1.List(name);
        board.addList(list);
        Storage.setLocalStorage();
    };
    Storage.changeListName = function (newName, listIndex, boardIndex) {
        var list = Storage.boards[boardIndex].lists[listIndex];
        list.changeName(newName);
        Storage.setLocalStorage();
    };
    Storage.moveList = function (oldPosition, newPosition, boardIndex) {
        Storage.boards[boardIndex].moveList(oldPosition, newPosition);
        Storage.setLocalStorage();
    };
    Storage.removeList = function (listIndex, boardIndex) {
        Storage.boards[boardIndex].removeList(listIndex);
        Storage.setLocalStorage();
    };
    // cards manipulation
    Storage.createCard = function (name, description, priority, listIndex, boardIndex) {
        var list = Storage.boards[boardIndex].lists[listIndex];
        var card = new Card_1.Card(name, description, priority);
        list.addCard(card);
        Storage.setLocalStorage();
    };
    Storage.removeCard = function (cardPosition, listIndex, boardIndex) {
        var list = Storage.boards[boardIndex].lists[listIndex];
        list.removeCard(cardPosition);
        Storage.setLocalStorage();
    };
    Storage.moveCard = function (oldPosition, newPosition, listIndex, boardIndex) {
        var list = Storage.boards[boardIndex].lists[listIndex];
        list.moveCard(oldPosition, newPosition);
        Storage.setLocalStorage();
    };
    Storage.changeCardTitle = function (newTitle, cardIndex, listIndex, boardIndex) {
        var card = Storage.boards[boardIndex].lists[listIndex].cards[cardIndex];
        card.changeTitle(newTitle);
        Storage.setLocalStorage();
    };
    Storage.changeCardDescription = function (newDescription, cardIndex, listIndex, boardIndex) {
        var card = Storage.boards[boardIndex].lists[listIndex].cards[cardIndex];
        card.changeDescription(newDescription);
        Storage.setLocalStorage();
    };
    Storage.changeCardPriority = function (newPriority, cardIndex, listIndex, boardIndex) {
        var card = Storage.boards[boardIndex].lists[listIndex].cards[cardIndex];
        card.changePriority(newPriority);
        Storage.setLocalStorage();
    };
    return Storage;
}());
exports.default = Storage;
